// components/ConfirmDeleteDialog.tsx
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { Button } from '@mui/material'

interface ConfirmDeleteDialogProps {
  open: boolean
  onClose: () => void
  onDelete: () => void
  title: string
  content: string
}

const ConfirmDeleteDialog = ({ open, onClose, onDelete, title, content }: ConfirmDeleteDialogProps) => {
  return (
    <Dialog fullWidth maxWidth="xs" open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>{content}</DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={onDelete}>Confirm</Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDeleteDialog
